import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';

/** 退货单截止时间提示：根据 displayStatus 与平台计算是否展示及文案 */
export function useReturnTimeTip(
  platform: Conversation.Trade.TradeWithLogistics['platform'],
  refundReason: Conversation.Trade.RefundReason,
) {
  const { t } = useTranslate();
  const {
    displayStatus,
    dueDateMs,
    sellerEvidenceDeadlineMs,
    sellerCompensationDueDateMs,
    offerDueDateMs,
  } = refundReason;

  const timeTip = useMemo(() => {
    const needTimeTipMap: Record<string, string> = {
      WAITING_EVIDENCE: sellerEvidenceDeadlineMs,
      PENDING_RESPOND: offerDueDateMs,
      REFUND_APPROVED: sellerCompensationDueDateMs,
      REVERSE_PENDING: dueDateMs,
    };

    const shouldShowTimeTip = () => {
      if (platform === 'mercado' && displayStatus === 'REVERSE_PENDING') {
        return true;
      }
      return ['WAITING_EVIDENCE', 'PENDING_RESPOND', 'REFUND_APPROVED'].includes(displayStatus);
    };

    const shouldShowTimeTipOnLazada = () =>
      platform === 'lazada' && displayStatus === 'REQUEST_INITIATE' && dueDateMs !== '0';

    if (shouldShowTimeTipOnLazada()) {
      return `SLA: ${dayjs(toNumber(dueDateMs)).format('YYYY-MM-DD HH:mm:ss')}`;
    }

    if (shouldShowTimeTip()) {
      const statusTime = needTimeTipMap[displayStatus];
      if (statusTime !== undefined && statusTime !== '0') {
        return t('trade.截至时间回应', {
          time: dayjs(toNumber(statusTime)).format('YYYY-MM-DD HH:mm:ss'),
        });
      }
      if (dueDateMs !== '0') {
        return dayjs(toNumber(dueDateMs)).format('YYYY-MM-DD HH:mm:ss');
      }
    }

    return '';
  }, [
    platform,
    displayStatus,
    dueDateMs,
    sellerEvidenceDeadlineMs,
    offerDueDateMs,
    sellerCompensationDueDateMs,
    t,
  ]);

  return {
    /** 有值时可展示，空字符串表示不展示 */
    timeTip: timeTip || null,
  };
}
